import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { SideNav } from 'app-components';
import { BREAK_POINTS } from '../../../../constants/common/breakpoints';

const StyledSidebarContainer = styled.div<React.ComponentPropsWithRef<'div'>>`
    border-radius: 6px;
    padding-top:45px;
    display: flex;
    flex-direction: column;
    width: 24%;
    .gi-sidebar_nav_list {
        background: ${({ theme }) => theme.defaultWhite};
        font-weight: 400;
    }
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
    }
    .theme-bg {
        padding:15px;
        background-color: ${({ theme }) => theme.infoLightest} !important;
    }
    .side-bar-header {
        padding:15px;
        background-color: ${({ theme }) => theme.gray9} !important;
    }
    .side-bar-option {
        padding:15px;
    }
`;

const SidebarBottom = () => {

    return (
        <StyledSidebarContainer className='manage-drugs-side-nav' data-testid="dynamic-security-side-nav-continer">
            <SideNav.Item>
                <ul className="nav nav-list side-bar-header">
                    <li className="active" data-testid="dynamic-security-side-nav-search">
                        <span>
                            <FormattedMessage id='dynamicSecurityQuestion.process' />
                        </span>
                    </li>
                </ul>
                <ul className="nav nav-list theme-bg">
                    <li className="active" data-testid="dynamic-security-side-nav-search">
                        <FormattedMessage id='dynamicSecurityQuestion.securityQuestions' />
                    </li>
                </ul>
                <ul className="nav nav-list side-bar-option">
                    <li className="active" data-testid="dynamic-security-side-nav-search">
                        <FormattedMessage id='dynamicSecurityQuestion.linkApplication' />
                    </li>
                </ul>
            </SideNav.Item>
        </StyledSidebarContainer>
    );
};

export default SidebarBottom;
